import {alpha, SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const wrapperSx: SxProps<Theme> = {
    padding: theme.spacing(20 / 8),
    marginTop: theme.spacing(20 / 8),
};

export const actionsWrapperSx: SxProps<Theme> = {
    padding: theme.spacing(20 / 8, 24 / 8),
    borderTop: `${theme.spacing(1 / 8)} solid ${theme.palette.neutral[200]}`,
    background: theme.palette.neutral[50],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(20 / 8),
};

/**
 * The same confirmation on a phone.
 *
 * A question set in the body size, with Cancel and Delete side by side at the bottom of a
 * full-height dialog, asks for a decision in the register of a form field and puts the irreversible
 * answer a thumb's width from the harmless one. Here the mark says what kind of act this is before
 * the words do, the question carries the weight of a heading, and the two answers are stacked: the
 * dangerous one is pressed deliberately, the way back is the wider target under it.
 */
export const phoneConfirmSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '14px',
    minHeight: '60vh',
    padding: '24px 20px 20px',
};

export const phoneIconSx: SxProps<Theme> = {
    width: 56,
    height: 56,
    flexShrink: 0,
    borderRadius: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: alpha(theme.palette.brand.main, 0.12),
    color: theme.palette.brand.main,
    '& svg': {
        fontSize: '26px',
    },
};

export const phoneQuestionSx: SxProps<Theme> = {
    fontSize: '18px',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    textAlign: 'center',
    color: theme.palette.text.primary,
};

/** What is about to be changed, named. The only thing the caller has beyond the question itself. */
export const phoneCaptionSx: SxProps<Theme> = {
    fontSize: '14px',
    lineHeight: 1.5,
    textAlign: 'center',
    color: theme.palette.neutral[600],
};

export const phoneActionsSx: SxProps<Theme> = {
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    paddingTop: '4px',
};

export const phoneDangerButtonSx: SxProps<Theme> = {
    height: 48,
    borderRadius: '12px',
    textTransform: 'none',
    fontSize: '15px',
    fontWeight: 600,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.brand.main,
    boxShadow: `0 4px 12px ${alpha(theme.palette.brand.main, 0.28)}`,
    '&:hover': {
        backgroundColor: theme.palette.brand.dark,
        boxShadow: `0 4px 12px ${alpha(theme.palette.brand.main, 0.28)}`,
    },
};

export const phoneKeepButtonSx: SxProps<Theme> = {
    height: 48,
    borderRadius: '12px',
    textTransform: 'none',
    fontSize: '15px',
    fontWeight: 600,
    border: `1px solid ${theme.palette.neutral[200]}`,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    '&:hover': {
        border: `1px solid ${theme.palette.neutral[300]}`,
        backgroundColor: theme.palette.common.white,
    },
};
